import { Component } from '@angular/core'
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap'
import { CellComponent } from '@spartacus/organization/administration/components'

@Component({
  selector: 'eb-product-variants-table-default',
  templateUrl: './eb-product-variants-table-default.component.html',
  imports: [NgbTooltip]
})
export class EbProductVariantsTableDefaultComponent extends CellComponent {}
